import { render } from "./ShowPackedSku.vue?vue&type=template&id=b70edcbc"
import script from "./ShowPackedSku.vue?vue&type=script&lang=js"
export * from "./ShowPackedSku.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./ShowPackedSku.vue?vue&type=style&index=1&id=b70edcbc&lang=css"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__